import { createAsyncThunk } from '@reduxjs/toolkit';

import { MosaferatiApiPaths } from 'Feature/Mosaferati/Common/Constant/MosaferatiApiPaths';
import {
  MosaferatiHttpGetService,
  MosaferatiHttpPostService,
} from 'Feature/Mosaferati/Common/Services/MosaferatiHttpService';

export const getNoeGharardadSafarCountryByCountryCoreId = createAsyncThunk(
  'Mosaferati/getNoeGharardadSafarCountryByCountryCoreId',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.TarhSafar.GetNoeGharardadSafarByCountryCoreId}`,
      params: query,
    });
  }
);

export const getDestinationCountry = createAsyncThunk('Mosaferati/DestinationCountry', async () => {
  return await MosaferatiHttpGetService({
    url: `${MosaferatiApiPaths.DestinationCountry.GetCountries}`,
  });
});

export const getActiveTarhHayeSafarByNoeGharardadSafarCoreIdAndCountryCoreId = createAsyncThunk(
  'Mosaferati/getActiveTarhHayeSafarByNoeGhrardadSafarCoreIdAndCountryCoreId',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.TarhSafar.GetActiveTarhHayeSafarByNoeGharardadSafarCoreIdAndCountryCoreId}`,
      params: query,
    });
  }
);

export const estelamMosaferati = createAsyncThunk('Mosaferati/Estelam', async (command: any) => {
  return await MosaferatiHttpPostService({
    url: `${MosaferatiApiPaths.BimehNameh.Estelam}`,
    body: command,
  });
});

export const addBimehNamehMosaferatiToOrder = createAsyncThunk(
  'addBimehNamehMosaferatiToOrder',
  async (command: any) => {
    return await MosaferatiHttpPostService({
      url: `${MosaferatiApiPaths.BimehNameh.AddBimehNamehMosaferatiToOrder}`,
      body: command,
    });
  }
);

export const printBimehNamehMosaferatiById = createAsyncThunk(
  'BimehNamehMosaferati/printBimehNamehMosaferatiById',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.BimehNameh.PrintBimehNamehMosaferatiById}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);